import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Route, Routes, createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom';
import { ClipLoader } from "react-spinners";
import { retry } from '../../utils/PromiseRetry';
import { PublicRoute } from './routesConfig';


const Home = lazy(() => retry(() => import('../components/Home/index')));
const ThankYouPage = lazy(() => retry(() => import('../components/ThankYouPage')));
const InspireGallery = lazy(() => retry(() => import('../components/InspireGallery')));
const InspireGalleryDetails = lazy(() => retry(() => import('../components/InspireGallery/InspireGalleryDetails')));

const JoinTheConversationForm = lazy(() => retry(() => import('../components/JoinTheConversationForm')));

const router = createBrowserRouter([
    {
        path: '/',
        errorElement: <Navigate to={"/"} />,
        children: [
            { path: "/", element: <PublicRoute element={<Home />} /> },
            { path: "join-the-conversation", element: <PublicRoute element={<JoinTheConversationForm />} /> },
            { path: "thank-you", element: <PublicRoute element={<ThankYouPage />} /> },
            { path: "gallery", element: <PublicRoute element={<InspireGallery />} /> },
            { path: "gallery/:slug", element: <PublicRoute element={<InspireGalleryDetails />} /> },
        ],
    },
]);


const AppRouter = () => {
    return (
        <Suspense fallback={
            <span style={{ textAlign: "center", display: "block" }}>
                <div style={{ display: "inline-block", marginTop: "300px" }}>
                    <ClipLoader
                        color={"#41d4ce"}
                        loading={true}
                        size={150}
                        aria-label="Loading Spinner"
                        data-testid="loader"
                    />
                </div>
            </span>}>
            <RouterProvider router={router} />
        </Suspense>
    );
}

export default AppRouter;
